import type { Sector } from "~/modules/sector/models/Sector.interface";

/**
 * Return the list of the granted sectors.
 * Based on the granted status of each sector or if a parent sector is granted then all the children are granted.
 * @param sectors
 * @param granted boolean true if all the sectors of the parameter sectors must be returned, false otherwise.
 * @param initialValue
 */
export function getGrantedSectors(
  sectors: Sector[],
  granted: boolean = false,
  initialValue: Sector[] = [],
): Sector[] {
  return sectors.reduce((previousValue, currentValue) => {
    const grantedSectors = [
      ...previousValue,
      ...getGrantedSectors(
        currentValue.children ?? [],
        granted || currentValue.statuses.granted,
        [],
      ),
    ];
    return granted || currentValue.statuses.granted
      ? [...grantedSectors, currentValue]
      : grantedSectors;
  }, initialValue);
}
